<template>
    <section class="content">
      <box>
        <div slot="body">
            <div class="row">
              <div class="col-md-6">
                  <h4>Descrição</h4>
                  <input v-model="categories.descricao" type="text" class="form-control" >
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <h4>Imagem </h4>
                <input type="file" id="file-input" class="form-control">
                <p id="status">Please select a file</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <h4>Ativo</h4><br>
                <toggle-button 
                  v-model="categories.ativo"
                  :color="color" 
                  :sync="true" />
              </div>
            </div>
            <br>
            <br><br>
            <router-link class="pageLink" to="/categorias-servicos">
                    <button class="btn btn-danger" >Cancelar</button>
            </router-link>
            <button class="btn btn-success" @click="gravar" v-show="categories.descricao!='' && !gravando"><i class="fa fa-check"></i>  Gravar</button>
            <button v-show="gravando" class="btn btn-success"><i class="fa fa-spinner fa-spin"></i>  Gravando</button>
        </div>
    </box>
        
    </section>
</template>
<script>
import Box from '../Box' // importando modal
import resourceCategorias from './resource'
import s3 from '../../../services/s3'

export default {
  name: 'NovaCategoriaServico',
  components: {
    'box': Box
  },
  data () {
    return {
      nome: '',
      categories: {
        descricao: '',
        ativo: false,
        url_imagem: ''
      },
      gravando: false,
      imagem: '',
      editar: false,
    }
  },
  created () {
    if(this.$route.params.id) {
      this.getCategoriaById(this.$route.params.id)
      this.editar = true
    }
  },
  methods: {
    gravar () {
      this.gravando = true
      const files = document.getElementById('file-input').files;
      const file = files[0];


      if(file != null) {
        s3.getSignedRequest(file).then(res => {
          this.categories.url_imagem = res.url;
          this.gravarCategoria();
        }).catch(err => {
          alert('Erro ao salvar imagem');
        })
      } else {
        if(this.editar) {
          this.gravarCategoria();
        } else {
          alert('É necessário selecionar uma imagem.');
          this.gravando = false
        }
      }
    },
    gravarCategoria(){
        // this.categories.url_imagem = 'http://site.dl.com.br/app/uploads/2018/04/img/ferramenta_sem_cor.png'
        this.categories.empresa = localStorage.getItem('FB_ID');

        if(this.editar) {
          resourceCategorias.atualizarCategoria(this.categories, this.$route.params.id).then((res) => {
            console.log('res => ', res);
            this.$router.go(-1);
          }).catch(err => {
              alert(JSON.stringify(err));
            })
        } else {
            resourceCategorias.gravarCategoria(this.categories).then((res) => {
                console.log('res => ', res);
                this.$router.go(-1);
            }).catch(err => {
                alert(JSON.stringify(err));
            })
        }
    },
    getCategoriaById (id) {
       resourceCategorias.getCategoriaById(id).then((res) => {
           this.categories = res.data
       })
    }
  }
}
</script>



// WEBPACK FOOTER //
// novaCategoria.vue?39fde5a7